<template>
  <v-card>
    <v-card-title class="main-red-bg white--text">
      <span class="text-h5">Upload Users</span>
    </v-card-title>
    <v-divider class="mb-2"></v-divider>
    <v-card-text>
      <v-form v-model="isUploadFormValid" ref="uploadForm">
        <v-container>
          <v-row>
            <v-col cols="12" sm="12">
              <v-file-input v-model="uploadFile" accept=".csv" label="File input" :rules="[validators.required]"></v-file-input>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="error" class="ma-2 white--text px-3" @click="closeDialog"> Cancel </v-btn>
      <v-btn :disabled="!isUploadFormValid" :loading="loadingSubmit" @click="upload" color="success" class="ma-2 white--text px-3">
        <v-icon left dark> mdi-send </v-icon>
        Upload
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import validators from '@/helpers/validationHelper';
export default {
  name: 'UploadUsers',
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      isUploadFormValid: false,
      loadingSubmit: false,
      validators: validators,
      uploadFile: null,
    };
  },
  methods: {
    async upload() {
      this.loadingSubmit = true;
      const revalidatedForm = this.$refs.uploadForm.validate();
      if (revalidatedForm) {
        await this.$store.dispatch('sectionsModule/importUsers', {
          uploadFile: this.uploadFile,
          sectionId: this.id,
        });
      }
      this.loadingSubmit = false;
      this.closeDialog();
    },
    closeDialog() {
      this.$refs.uploadForm.reset();
      this.uploadFile = null;
      this.$emit('closeDialog', 'upload');
    },
  },
};
</script>
